import { zip } from 'fflate';

/**
 * Packs one in-memory file into a ZIP archive, in the browser.
 *
 * THE ONLY fflate IMPORT SITE IN THE APP — keep it that way, so swapping the
 * library later touches exactly one file.
 *
 * fflate was chosen over `client-zip` (~3 kB but STORE-only, so the archive
 * would be the same size as the input) and `jszip` (~100 kB). The async `zip`
 * entry point is used rather than `zipSync` so a large instance does not block
 * the main thread.
 *
 * The async `zip` entry point builds its Web Worker from a `blob:` URL — there
 * is no Content-Security-Policy in this repo today, but if one is ever added
 * to `deploy/nginx/mbrs-frontend.conf`, it will need `worker-src blob:` or
 * this stops working silently.
 */
export function zipSingleFile(entryName: string, bytes: Uint8Array): Promise<Blob> {
  return new Promise<Blob>((resolve, reject) => {
    zip({ [entryName]: bytes }, (err, data) => {
      if (err) {
        reject(err);
        return;
      }
      resolve(new Blob([data], { type: 'application/zip' }));
    });
  });
}
